import React from 'react'

import { DateField } from 'react-admin'

export const LocalDateField = (props) => (
  <DateField
    {...props}
    locales="es"
    options={{
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }}
  />
)
